<template>
  <div class="pve-main-container">
    <h1>PVE 主界面</h1>
    <button @click="navigateToBattle('wild')">开启野怪对战</button>
    <button @click="navigateToBattle('trainer')">开启训练师挑战</button>
  </div>
</template>

<script>
import { usePveStore } from "@/stores/pveStore";

export default {
  name: "PveMain",
  methods: {
    navigateToBattle(type) {
      const pveStore = usePveStore();
      let opponentConfig = {};

      if (type === "wild") {
        opponentConfig = { type: "wild", pokemonId: 1, level: 50 };
      } else if (type === "trainer") {
        opponentConfig = { type: "trainer", id: 101 };
      }

      // 将对战配置存储到 Pinia
      pveStore.setOpponentConfig(opponentConfig);
      console.log(`已设置对手信息:`, opponentConfig);

      // 跳转到战斗总控制界面
      this.$router.push("/pve/controller");
    },
  },
};
</script>

<style scoped>
.pve-main-container {
  text-align: center;
  margin-top: 50px;
  background-color: #fff; /* 白色背景 */
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 2em;
  margin-bottom: 20px;
}

button {
  display: block;
  margin: 10px auto;
  padding: 10px 20px;
  font-size: 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #0056b3;
}
</style>
